export enum DocumentType {
  MT940 = 'mt940',
  Ownership = 'ownership',
  Other = 'other',
}

export interface FileConfig {
  allowedFileExtensionsDisplayed: string[];
  allowedFileFormats: string[];
  maxSize: number;
  maxFiles: number;
  documentType: DocumentType;
}

export type FileConfigByDocumentType = {
  [key in DocumentType]: FileConfig;
};

const defaultFileConfig: FileConfig = {
  allowedFileExtensionsDisplayed: [
    '.csv',
    '.xlsx',
    '.pdf',
    '.jpg',
    '.jpeg',
    '.png',
  ],
  allowedFileFormats: [
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
    'image/jpeg',
    'image/png',
  ],
  maxFiles: 4,
  maxSize: 15000000,
  documentType: DocumentType.Other,
};

export const fileConfigByDocumentType: FileConfigByDocumentType = {
  [DocumentType.MT940]: {
    allowedFileExtensionsDisplayed: ['.swi', '.STA', '.940', '.txt'],
    allowedFileFormats: ['text/plain'],
    maxSize: 15000000,
    documentType: DocumentType.MT940,
    maxFiles: 4,
  },
  [DocumentType.Ownership]: {
    allowedFileExtensionsDisplayed: ['.pdf', '.jpg', '.jpeg', '.png'],
    allowedFileFormats: [
      'image/png',
      'application/pdf',
      'image/jpeg',
      '.pdf',
      '.jpg',
      '.jpeg',
      '.png',
    ],
    maxSize: 15000000,
    documentType: DocumentType.Ownership,
    maxFiles: 5,
  },
  [DocumentType.Other]: defaultFileConfig,
};
